import {Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild} from '@angular/core';
import {CalculatedChargeModel} from '../../../models/CalculatedChargeModel';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatSort, Sort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import {Subscription} from 'rxjs';
import {Offset} from '../../../models/Offset';
import {GenericArray} from '../../../models/GenericArray';
import {DialogDetailComponent} from '../../general-components/dialog-detail/dialog-detail.component';
import {CalculatedChargesService} from './service-calculated-charges/calculated-charges.service';
import {NumAnnoMeseService} from '../../general-services/service-num-anno-mese/num-anno-mese.service';
import {LoaderService} from '../../general-services/service-loader/loader.service';
import {BaseGeneralComponent} from '../../BaseGeneralComponent';
import {Router} from '@angular/router';
import {ContractTypeService} from '../../general-services/service-contract-type/contract-type.service';
import {UsersService} from '../../users/service/users.service';
import { debounceTime, delay, tap } from 'rxjs/operators';

@Component({
  selector: 'app-calculated-charges',
  templateUrl: './calculated-charges.component.html',
  styleUrls: ['./calculated-charges.component.scss']
})
export class CalculatedChargesComponent extends BaseGeneralComponent implements OnInit, OnDestroy {

  sectionId: string;

  displayedColumns: Array<string>;
  dataSource: any;
  isCalculatedChargeSection: boolean;
  selectedRowIndex: number;
  listData: MatTableDataSource<any>;
  getPageSubscribe: Subscription;
  deleteElementSubscribe: Subscription;

  offset: Offset;
  filter: CalculatedChargeModel;
  numAnnoMeseData: any;
  contractTypeData: any;
  showNewEditDelete: boolean;
  showFilter = true;

  @Input() showActions?: boolean;
  @Input() idSelected?: number;
  @Input() inServiceChanges?: boolean;
  @Input() reportSection?: boolean;

  @Output() elementSelected = new EventEmitter();

  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;

  constructor(private calculatedChargesService: CalculatedChargesService,
              private numAnnoMeseService: NumAnnoMeseService,
              private contractTypeService: ContractTypeService,
              private userService: UsersService,
              private loaderService: LoaderService,
              private dialog: MatDialog,
              private router: Router) {
    super();
    this.loaderService.display(true);
    this.showActions = true;
    this.sectionId = this.SECTIONS.MONTHLY_CHARGES;
    this.user = JSON.parse(sessionStorage.getItem('user'));
    this.filter = new CalculatedChargeModel();
  }

  ngOnInit() {
    this.isCalculatedChargeSection = this.returnIsContractSection(this.router.url);
    this.showNewEditDelete = !this.checkRole();
    this.showFilter = false;
    this.selectedRowIndex = this.idSelected;
    this.displayedColumns = ['NumAnnoRif', 'regionCod', 'localCustomerCod',
      'contractType', 'resourceUnitCod',  'charge', 'isVolumeRecovery', 'actions'];
    this.offset = this.setOffsetInSession(this.offset, this.OFFSET_NAME.CALCULATED_CHARGE);
    this.userService.getUserSectionGrant(this.user.id, this.sectionId).subscribe(
      (result: any) => {
        this.setUserGrants(result);
      });
    this.getSessionStorageFilter();
    this.init();
  }

  init() {
    this.filter.provider = JSON.parse(sessionStorage.getItem(this.SESSION_STORAGE_LABELS.DEFAULT_PROVIDER_SELECTED));

    this.numAnnoMeseService.getAllMonth(this.filter.provider, this.filter.contractType).subscribe(
      (resultYearMonth: any) => {
        this.numAnnoMeseData = resultYearMonth;

        if (!this.filter.numAnnoMese || !BaseGeneralComponent.isNumAnnoMeseInFilterList(this.filter.numAnnoMese, this.numAnnoMeseData)) {
          this.filter.numAnnoMese = resultYearMonth[0] ? resultYearMonth[0] : null;
        }

        if (!this.reportSection) {
          // this.showFilter = false;
          this.getDataPage(this.offset, this.filter);
        } else {
          this.showFilter = true;
        }          }, error => {
        console.log(error);
        this.loaderService.display(false);
    });

  }
  getDataPage(offset: Offset, filter: CalculatedChargeModel) {
    this.loaderService.display(true);
    this.getPageSubscribe = this.calculatedChargesService.getPage(offset, filter)
    .pipe(
      tap(() => this.loaderService.display(true)),
      debounceTime(0),
      delay(0),
      tap(() => this.loaderService.display(false)),
    ).subscribe(
        (resultPage: any) => {
          this.dataSource = resultPage.content;
          this.listData = new MatTableDataSource(this.dataSource);
          this.listData.sort = this.sort;
          this.paginator.pageIndex = offset.pageIndex;
          this.paginator.showFirstLastButtons = true;
          this.paginator.length = resultPage.totalElements;
          this.loaderService.display(false);
        });
  }

  openDialog(id: number) {
    const deltaChargesDetData = this.dataSource.find(data => data.id === id);
    const list: GenericArray[] = [
      {id: 'Month', value: this.toCustomStringAnnoMese(deltaChargesDetData.numAnnoMese)},
      {id: 'Region Cod', value: this.toCustomString(deltaChargesDetData.region.cod)},
      {id: 'Region Description', value: this.toCustomString(deltaChargesDetData.region.description)},
      {id: 'Local Customer Cod', value: this.toCustomString(deltaChargesDetData.localCustomer.cod)},
      {id: 'Local Customer Description', value: this.toCustomString(deltaChargesDetData.localCustomer.description)},
      {id: 'Contract Type Cod', value: this.toCustomString(deltaChargesDetData.contractType.cod)},
      {id: 'Contract Type Description', value: this.toCustomString(deltaChargesDetData.contractType.description)},
      {id: 'Resource Unit', value: this.toCustomString(deltaChargesDetData.resourceUnit.name)},
      {id: 'Charge', value: this.toCustomString(deltaChargesDetData.charge)},
      {id: 'Volume Recovery', value: this.toCustomStringIs(deltaChargesDetData.isVolumeRecovery)},
    ];
    this.dialog.open(DialogDetailComponent, {
      width: '40%',
      data: {list}
    });
  }

  getNext(event: PageEvent) {
    this.loaderService.display(true);
    const tmpOffset = new Offset(event.pageSize, event.pageIndex);
    this.setOffsetInSession(tmpOffset, this.OFFSET_NAME.CALCULATED_CHARGE);
    tmpOffset.orderDirection = this.offset.orderDirection;
    tmpOffset.orderField = this.offset.orderField;
    this.offset = tmpOffset;
    this.getDataPage(this.offset, this.filter);
  }

  getDataFiltered(dataFiltered: any) {
    this.offset = new Offset(+this.PAGINATOR.PAGE_SIZE_ARRAY[0], 0);
    this.filter = dataFiltered;
    if (!this.reportSection) {
      this.getDataPage(this.offset, this.filter);
    }  }

  sortData(sort: Sort) {
    this.loaderService.display(true);
    if ((sort.active !== null || true || sort.active !== '') && (sort.direction !== '' || sort.direction !== null || true)) {
      if (this.offset === null || this.offset === undefined) {
        this.offset = new Offset(+this.PAGINATOR.PAGE_SIZE_ARRAY[0], 0);
      }

      this.offset.orderField = sort.active;
      this.offset.orderDirection = sort.direction;

      this.getDataPage(this.offset, this.filter);
    }

  }

  selectRow(row: any) {
    this.selectedRowIndex = row.id;
    this.elementSelected.emit({ row });
  }

  ngOnDestroy(): void {
    if (this.getPageSubscribe) {
      this.getPageSubscribe.unsubscribe();
    }
    if (this.deleteElementSubscribe) {
      this.deleteElementSubscribe.unsubscribe();
    }
  }

  toggleFilter() {
    if (!this.reportSection) {
      this.showFilter = !this.showFilter;
    }
  }

  getSessionStorageFilter() {
    const filter_ = JSON.parse(sessionStorage.getItem(this.SESSION_STORAGE_LABELS.CALCULATED_CHARGE_FILTER));
    this.filter = filter_ ? filter_ : new CalculatedChargeModel();
  }
}
